import toast from "lib/toast";

import { DriverNotifier } from "./driverEffects";

export const toastNotifier: DriverNotifier = {
  error(message: string) {
    toast.error(message);
  },
  internalError(internalError: string) {
    // eslint-disable-next-line no-console
    console.error(internalError);
  },
  warning(message: string) {
    toast.warning(message);
  },
  info(message: string) {
    toast.info(message);
  },
};
